















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  inheritAttrs: false,
  components: {},
})
export default class StCheckbox extends Vue {
  @Prop() name!: string;
  @Prop() value!: boolean;
  @Prop() disabled!: boolean;

  update(event: any)
  {
    this.$emit('input', event.target.checked);
  }
}
